import { createContext } from 'react';
export var LoadingContext = createContext({
    loading: false,
    setLoading: null
});
